<template>
  <div>
    <b-field
      :type="validator.inputFieldClass"
      :message="validator.inputFieldMessage"
      expanded>
      <b-select v-if="hasOptions"
        v-model="currentValue"
        :disabled="!isEditable"
        :readonly="!isEditable"
        @input="announce"
        expanded>
        <option value="">- No Value -</option>
        <option v-for="(option, index) in options" :value="option" :key="index">{{ option }}</option>
      </b-select>
      <b-input v-else
        v-model="currentValue"
        placeholder=""
        :disabled="!isEditable"
        :readonly="!isEditable"
        @input="announce"
        expanded />
    </b-field>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['context']),
    isEditable () {
      if (this.attribute.rule.attribute.code === 'identifier' && this.context.isMerchant()) return false
      if (this.attribute.rule.attribute.editable_by === 'any' || this.attribute.rule.attribute.editable_by === null) return true
      if (this.context.isMerchant() && this.attribute.rule.attribute.editable_by === 'retailer') return true
      if (this.context.isSupplier() && this.attribute.rule.attribute.editable_by === 'brand') return true
      return false
    },
    hasOptions () {
      return Boolean(this.attribute.rule.rule_validators[0]?.values.length)
    },
    options () {
      return this.attribute.rule.rule_validators[0]?.values
    },
    validator () {
      const validator = {
        inputFieldClass: null,
        inputFieldMessage: null
      }
      if (this.attribute.rule.is_required === true && (this.currentValue === null || this.currentValue === '')) {
        return {
          inputFieldClass: 'is-warning',
          inputFieldMessage: 'A value for this field is required.'
        }
      }
      if (this.currentValue && this.hasOptions && !this.options.includes(this.currentValue)) {
        return {
          inputFieldClass: 'is-warning',
          inputFieldMessage: 'The current value is not allowed. Please select a valid value.'
        }
      }
      if (this.originalValue !== this.currentValue) {
        return {
          inputFieldClass: 'is-info',
          inputFieldMessage: null
        }
      }
      return validator
    }
  },
  data () {
    return {
      originalValue: null,
      currentValue: null
    }
  },
  methods: {
    announce () {
      this.$emit('input', {
        attribute: {
          code: this.attribute.rule.attribute.code
        },
        value: this.currentValue
      })
    }
  },
  mounted () {
    if (this.attribute.value) {
      // determine if value exists
      if (this.attribute.value.values.length) {
        if (Array.isArray(this.attribute.value.values[0].value)) {
          this.originalValue = this.attribute.value.values[0].value[0]
          this.currentValue = this.attribute.value.values[0].value[0]
        } else {
          this.originalValue = this.attribute.value.values[0].value
          this.currentValue = this.attribute.value.values[0].value
        }
      }
    }
  },
  props: {
    attribute: {
      type: Object,
      required: true
    }
  }
}
</script>
